/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import {
  get, map, remove, size, split,
  take, isEmpty,
} from 'lodash';
import { Delete, AddShoppingCart, LockOpenOutlined, Loyalty } from '@material-ui/icons';
import { Box, SwipeableDrawer, styled } from '@material-ui/core';
import {
  setCart, setAddresses, setProducts, setAnonymousCart,
} from '../../../Actions';
import { decode } from '../Shared/encode';
import { deleteCartProduct, removeSubscription } from '../Shared/helpers';
import { defaultErrorMessage, isEventBooking, hasUuid } from '../../../constants';
import { seDeleteFromCart } from '../../Shared/WebAnalytics';
import ErrorModal from '../../Shared/ErrorModal';
import MemberPriceBadge from './MemberPriceBadge';

const drawerBleeding = 56;

const Puller = styled(Box)(() => ({
  width: 48,
  height: 4,
  backgroundColor: '#E2E2E2',
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 24px)',
}));
class CartDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      error: '',
      showErrorModal: false,
    };
    this.relevantItemsList = this.relevantItemsList.bind(this);
    this.mobileCart = this.mobileCart.bind(this);
    this.desktopCart = this.desktopCart.bind(this);
    this.isFullCart = this.isFullCart.bind(this);
    this.deleteSub = this.deleteSub.bind(this);
    this.errorModal = this.errorModal.bind(this);
    this.renderSoothePassItem = this.renderSoothePassItem.bind(this);
    this.getPriceDisplay = this.getPriceDisplay.bind(this);
    this.renderAddServicesBanner = this.renderAddServicesBanner.bind(this);
    this.renderCartItemPricing = this.renderCartItemPricing.bind(this);
    this.renderAnonymousCartItemPricing = this.renderAnonymousCartItemPricing.bind(this);
    this.getResponsiveBreakpoints = this.getResponsiveBreakpoints.bind(this);
    this.renderStickyPointsMessage = this.renderStickyPointsMessage.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', () => this.setState({ width: window.innerWidth }));
  }

  deleteSub() {
    const cartId = get(this.props, 'booking.cart.id', '');
    if (cartId) {
      removeSubscription(cartId, (response) => {
        this.props.assignToCart({ cart: decode(response.data.cart) });
      }, (err) => {
        this.setState({ showErrorModal: true, error: get(err, 'errors.0.message', defaultErrorMessage) });
      });
    }
  }

  errorModal() {
    return (
      <ErrorModal
        isOpen={this.state.showErrorModal}
        close={() => { this.setState({ showErrorModal: false, error: null }); }}
      >
        <p>{this.state.error}</p>
      </ErrorModal>
    );
  }

  renderSoothePassItem() {
    const soothePassObj = get(this.props, 'booking.cart.info_fields.soothe_pass', null);
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    const { has_discount, service_text } = get(this.props, 'client.soothe_pass.discount', {});

    if (alreadyAppliedToCart && !isEmpty(soothePassObj)) {
      return (
        <div className="notLast-br-b-opaque d-flex-only align-items-center justify-content-spaced">
          <div>
            <div className="size-18-24 font-weight-bold contentPrimary mt-16 mb-4">
              SoothePass™
            </div>
            <div className="size-16-24 contentSecondary mb-4">
              {get(soothePassObj, 'subscription_tier_name', '')}
              {', '}
              {get(soothePassObj, 'subscription_points', 0)}
              {' '}
              points
            </div>
            <div className={this.state.width <= 800 ? "sm-size-16-20 contentSecondary mb-4" : "size-16-24 contentSecondary mb-4"}>
              {get(soothePassObj, 'subscription_tier_price', '')}
            </div>
            {has_discount && service_text && (
              <div className="d-flex-only align-items-center mb-16" style={{ gap: this.state.width <= 800 ? '6px' : '8px' }}>
                <Loyalty 
                  style={{ 
                    fontSize: this.state.width <= 800 ? '18px' : '20px',
                    color: '#05944F' 
                  }} 
                />
                <div className={this.state.width <= 800 ? "sm-size-12-20" : "size-14-20"} style={{ color: '#05944F' }}>
                  {service_text}
                </div>
              </div>
            )}
          </div>
          <div className="pr-24">
            <button
              type="button"
              className="btn edit-icon"
              onClick={() => this.deleteSub()}
            >
              <Delete className="contentPrimary"/>
            </button>
          </div>
        </div>
      );
    }
    return null;
  }

  getResponsiveBreakpoints() {
    const width = this.state.width;
    return {
      isMobile: width <= 800,
      isTablet: width > 800 && width <= 1100,
      isDesktop: width > 1100,
      isLargeDesktop: width > 1200
    };
  }

  renderStickyPointsMessage() {
    const hasServices = this.hasServiceItems();
    const soothePassObj = get(this.props, 'booking.cart.info_fields.soothe_pass', null);
    const alreadyAppliedToCart = get(soothePassObj, 'subscription_applied_to_cart', false) && !isEmpty(soothePassObj);
    const { isMobile } = this.getResponsiveBreakpoints();

    // Show sticky message when both services and subscription exist
    if (hasServices && alreadyAppliedToCart) {
      return (
        <div 
          style={{ 
            position: isMobile? 'sticky' : 'absolute',
            bottom: isMobile? '0px' : '32px', // Add space above button for desktop
            left: isMobile? 'unset' :'0px',
            right: isMobile? 'unset' :'0px',
            backgroundColor: 'white',
            borderTop: '1px solid #E2E2E2',
            padding: '12px 16px',
            textAlign: 'center',
            zIndex: 10
          }}
        >
          <div 
            className={isMobile ? "sm-size-12-20" : "size-14-20"} 
            style={{ color: '#545454', lineHeight: '1.5em' }}
          >
            You'll be able to use your points at checkout.
          </div>
        </div>
      );
    }

    return null;
  }

  renderAddServicesBanner() {
    const hasServices = this.hasServiceItems();
    const hasSubscription = this.hasOnlySubscription();
    const soothePassObj = get(this.props, 'booking.cart.info_fields.soothe_pass', null);
    const alreadyAppliedToCart = get(soothePassObj, 'subscription_applied_to_cart', false) && !isEmpty(soothePassObj);
    const { isMobile, isTablet } = this.getResponsiveBreakpoints();

    // Show "Add services" banner when only subscription exists
    if (hasSubscription) {
      return (
        <div className={isMobile ? "p-16" : "p-24-16"}>
          <div 
            className="clickable"
            style={{ 
              backgroundColor: '#F1F6FF',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
            }}
            onClick={this.props.close}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                this.props.close();
              }
            }}
          >
            <div style={{ padding: '16px' }}>
              <AddShoppingCart style={{ 
                fontSize: isMobile ? '20px' : '24px', 
                color: '#323232' 
              }} />
            </div>
            <div style={{ padding: '16px 16px 16px 0px', flex: 1 }}>
              <div 
                className={isMobile ? "sm-size-12-20" : isTablet ? "size-14-20" : "size-16-24"} 
                style={{ color: '#000000', lineHeight: '1.5em' }}
              >
                <b>Add services now</b> - Your new points are waiting for you at checkout.
              </div>
            </div>
          </div>
        </div>
      );
    }



    return null;
  }

  renderCartItemPricing(cartProduct) {
    const isSoothePassSubscribed = get(this.props, 'booking.cart.info_fields.soothe_pass.subscribed', false);
    const isSoothePassAvailable = get(this.props, 'booking.cart.info_fields.soothe_pass.available', false) && !hasUuid();
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    const memberPrice = get(cartProduct, 'cart_product_main_option.member_price', '');
    const regularPrice = get(cartProduct, 'cart_product_main_option.price', '');
    const { isMobile, isTablet } = this.getResponsiveBreakpoints();
    const loggedIn = get(this.props, 'client.loggedIn', false);
    
    // Always show member pricing badge when SoothePass is available and member price exists
    // regardless of subscription status - this prompts users to subscribe or shows benefits
    const shouldShowMemberPricing = !loggedIn || (isSoothePassAvailable && memberPrice && memberPrice?.trim() !== '');

    if (shouldShowMemberPricing) {
      return (
        <div className={isMobile ? "sm-mb-16" : "mb-16"}>
          <div className="d-flex-only align-items-center mb-4" style={{ gap: '4px' }}>
            <MemberPriceBadge 
              option={get(cartProduct, 'cart_product_main_option', {})}
              client={this.props.client}
              booking={this.props.booking}
              fromModality={true}
              onClick={this.props.openSubscriptionPopup}
            />
          </div>
          <div className={isMobile ? "sm-size-12-20" : "size-14-20"} style={{ color: '#545454' }}>
            {regularPrice} Nonmember
          </div>
        </div>
      );
    }

    // Default pricing display when no member pricing available
    return (
      <div className={isMobile ? "sm-size-16-20 contentSecondary sm-mb-16" : "size-16-24 contentSecondary mb-16"}>
        {this.getPriceDisplay(cartProduct)}
      </div>
    );
  }

  renderAnonymousCartItemPricing(cartProduct) {
    const isSoothePassAvailable = get(this.props, 'client.soothe_pass.soothe_pass_available', false);
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    const memberPrice = get(cartProduct, 'member_price', '');
    const regularPrice = get(cartProduct, 'price', '');
    const { isMobile } = this.getResponsiveBreakpoints();
    const loggedIn = get(this.props, 'client.loggedIn', false);
    
    // Always show member pricing badge when SoothePass is available and member price exists
    // regardless of subscription status - this prompts users to subscribe or shows benefits
    const shouldShowMemberPricing = !loggedIn || (isSoothePassAvailable && memberPrice && memberPrice?.trim() !== '');

    if (shouldShowMemberPricing) {
      return (
        <div className={isMobile ? "sm-mb-16" : "mb-16"}>
          <div className="d-flex-only align-items-center mb-4" style={{ gap: '4px' }}>
            <MemberPriceBadge 
              option={cartProduct}
              client={this.props.client}
              booking={this.props.booking}
              fromModality={true}
              onClick={this.props.openSubscriptionPopup}
            />
          </div>
          <div className={isMobile ? "sm-size-12-20" : "size-14-20"} style={{ color: '#545454' }}>
            {regularPrice} Nonmember
          </div>
        </div>
      );
    }

    // Default pricing display when no member pricing available
    return (
      <div className={isMobile ? "sm-size-16-20 contentSecondary sm-mb-16" : "size-16-24 contentSecondary mb-16"}>
        {regularPrice}
      </div>
    );
  }

  isFullCart() {
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const anoncrtPrds = get(this.props, 'anonymousCart.cartProducts', []);
    const crtPrds = get(this.props, 'booking.cart.cartProducts', []);
    const maxItems = isEventBooking() ? 1 : 2;
    if (loggedIn) {
      return size(crtPrds) >= maxItems;
    }
    return size(anoncrtPrds) >= maxItems;
  }

  hasServiceItems() {
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const cartProducts = get(this.props, 'booking.cart.cartProducts', []);
    const anonCPs = get(this.props, 'anonymousCart.cartProducts', []);
    
    if (loggedIn) {
      return !isEmpty(cartProducts);
    } else {
      return !isEmpty(anonCPs);
    }
  }

  hasOnlySubscription() {
    const soothePassObj = get(this.props, 'booking.cart.info_fields.soothe_pass', null);
    const hasSubscription = get(soothePassObj, 'subscription_applied_to_cart', false) && !isEmpty(soothePassObj);
    return hasSubscription && !this.hasServiceItems();
  }
  
  getPriceDisplay(cartProduct) {
    const isSoothePassSubscribed = get(this.props, 'booking.cart.info_fields.soothe_pass.subscribed', false);
    const isSoothePassAvailable = get(this.props, 'booking.cart.info_fields.soothe_pass.available', false) && !hasUuid();
    const alreadyAppliedToCart = get(this.props, 'booking.cart.info_fields.soothe_pass.subscription_applied_to_cart', false);
    const subscription_membership_ends_date = get(this.props, 'client.soothe_pass.subscription_membership_ends_date', '');
    const memberPrice = get(cartProduct, 'cart_product_main_option.member_price', '');
    const regularPrice = get(cartProduct, 'cart_product_main_option.price', '');

    // If subscription is applied to cart, show "Free with SoothePoints at checkout"
    // if (isSoothePassAvailable && alreadyAppliedToCart) {
    //   return 'Free with SoothePoints at checkout';
    // }

    // If user is subscribed or has membership and member price is available, show member price
    if (memberPrice && isSoothePassAvailable && (isSoothePassSubscribed || subscription_membership_ends_date || alreadyAppliedToCart)) {
      return memberPrice;
    }

    // Otherwise show regular price
    return regularPrice;
  }

  relevantItemsList() {
    const cartProducts = get(this.props, 'booking.cart.cartProducts', []);
    const anonCart = get(this.props, 'anonymousCart', {});
    const anonCPs = get(anonCart, 'cartProducts', []);
    const loggedIn = get(this.props, 'client.loggedIn', false);
    const cartId = get(this.props, 'booking.cart.id', '');
    let listTobeUsed;
    const market = get(this.props, 'anonymousCart.address.market', '') || get(this.props, 'booking.cart.address.market', '');
    const is_event = isEventBooking();
    // TODO revisit title and price
    // TODO display only first cart product
    // TODO display only one remove icon 
    // TODO go back to event form when removing main cart product 
    // TODO maybe prefill event form with existing options?
    // TODO double check responsive code
    if (loggedIn) {
      listTobeUsed = is_event ? take(cartProducts) : cartProducts;
      return (
        <div className="">
          {this.renderSoothePassItem()}
          {map(listTobeUsed, (cp, it) => {
            const splittedSub = split(get(cp, 'subtitle', ''), ' with ', 2);
            return (
              <div key={`cart-item-${it}`} className="notLast-br-b-opaque d-flex-only align-items-center justify-content-spaced">
                <div>
                  <div className={this.state.width <= 800 ? "sm-size-18-24 font-weight-bold contentPrimary mt-16 mb-4" : "size-18-24 font-weight-bold contentPrimary mt-16 mb-4"}>
                    {get(splittedSub, 0, '')}
                    {get(splittedSub, 1, '') ? (
                      <>
                        <br />
                        with
                        {' '}
                        {get(splittedSub, 1, '')}
                      </>
                    ) : null}
                  </div>
                  {this.renderCartItemPricing(cp)}
                </div>
                <div className="pr-24">
                  <button
                    type="button"
                    className="btn edit-icon"
                    onClick={() => {
                      seDeleteFromCart(size(cartProducts), 'booking_23_variant', 'treatments_menu', market);
                      deleteCartProduct(cartId, cp.id, get(this.props, 'fieldsHolder.csrfToken', ''), (response) => {
                        this.props.assignToCart({ cart: decode(response.data.cart) });
                      }, (err) => this.setState({ showErrorModal: true, error: get(err, 'response.data.errors.0.message', defaultErrorMessage) }));
                    }}
                  >
                    <Delete className="contentPrimary"/>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      );
    }
    listTobeUsed = is_event ? take(anonCPs) : anonCPs;
    return (
      <div className="">
        {this.renderSoothePassItem()}
        {map(listTobeUsed, (cp, it) => (
          <div key={`cart-item-${it}`} className="notLast-br-b-opaque d-flex-only align-items-center justify-content-spaced">
            <div>
              <div className={this.state.width <= 800 ? "sm-size-18-24 font-weight-bold contentPrimary mt-16 mb-4" : "size-18-24 font-weight-bold contentPrimary mt-16 mb-4"}>
                {get(cp, 'title', '')}
                <br />
                {' '}
                {get(cp, 'subtitle', '')}
              </div>
              {this.renderAnonymousCartItemPricing(cp)}
            </div>
            <div className="pr-24">
              <button
                type="button"
                className="btn edit-icon"
                onClick={() => {
                  seDeleteFromCart(size(anonCPs), 'booking_23_variant', 'treatments_menu', market);
                  remove(anonCPs, (_el, j) => (j === it));
                  this.props.setAnonymousCart({ ...anonCart, cartProducts: anonCPs });
                }}
              >
                <Delete className="contentPrimary"/>
              </button>
            </div>
          </div>
        ))}
      </div>
    );
  }

  mobileCart() {
    const { open } = this.props;
    const { emCrt } = this.props;
    const rebook = get(this.props, 'booking.cart.rebook', false);

    return (
      <SwipeableDrawer
        PaperProps={{ style: { borderRadius: '16px 16px 0px 0px' } }}
        anchor="bottom"
        open={open}
        onClose={this.props.close}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen
        onOpen={() => { }}
      >
        {' '}
        <Puller />
        <div className="mt-8 p-12-16 centered br-b-opaque-2">
          <div className="size-18-24 font-weight-bold contentPrimary mb-4">Cart</div>
          {rebook || isEventBooking() ? null : <div className="size-12-20 contentSecondary">Add up to two treatments from the same category.</div>}
        </div>
        {emCrt ? <div className="size-16-24 contentSecondary centered-188 mt-60">Empty</div>
          : (
            <>
              <div className="sm-p-24-16">
                {this.relevantItemsList()}
              </div>
              {this.renderAddServicesBanner()}
              {this.renderStickyPointsMessage()}
              <div className="p-16">
                {this.isFullCart() ? null : (
                  <button
                    type="button"
                    className="btn btn-accent-light w-100-perc p-16-20-imp mb-8 size-18-24-imp"
                    onClick={this.props.close}
                  >
                    + Add Another
                  </button>
                )}
                {this.hasServiceItems() ? (
                  <button
                    type="button"
                    className="btn cta-primary"
                    onClick={this.props.next}
                    id="chooseDate"
                  >
                    {isEventBooking() ? "Next" : "Choose date"}
                  </button>
                ) : this.hasOnlySubscription() ? (
                  <button
                    type="button"
                    className="btn"
                    disabled
                    style={{
                      backgroundColor: '#F6F6F6',
                      color: '#AFAFAF',
                      borderRadius: '30px',
                      padding: this.state.width <= 800 ? '14px 18px' : '16px 20px',
                      width: '100%',
                      fontSize: this.state.width <= 800 ? '16px' : '18px',
                      fontWeight: '500',
                      border: 'none',
                      cursor: 'not-allowed'
                    }}
                  >
                    Choose Date
                  </button>
                ) : null}
              </div>
            </>
          )}
        {this.errorModal()}
      </SwipeableDrawer>
    );
  }

  desktopCart() {
    const rebook = get(this.props, 'booking.cart.rebook', false);
    return (
      <div className="top-sticky-80 height-100-perc">
        <div className="p-16-0-24-24">
          <div className="size-32-40 font-weight-bold contentPrimary mb-20">Cart</div>
          {rebook || isEventBooking() ? null : <div className="size-18-28 contentPrimary mb-40">Add up to two treatments from the same category.</div>}
          {this.relevantItemsList()}
          {this.renderAddServicesBanner()}
        </div>
        {this.renderStickyPointsMessage()}
        {this.hasServiceItems() ? (
          <div className="txt-center w-25-minus-48 fxd-btm r-24">
            <button
              type="button"
              className="btn cta-primary w-100-perc"
              id="chooseDate"
              onClick={this.props.next}
            >
              {isEventBooking() ? "Next" : this.state.width <= 1000 ? 'Choose date' : 'Next: Choose date'}
            </button>
          </div>
        ) : this.hasOnlySubscription() ? (
          <>
            {this.renderStickyPointsMessage()}
            <div className="txt-center w-25-minus-48 fxd-btm r-24">
            <button
              type="button"
              className="btn w-100-perc"
              disabled
              style={{
                backgroundColor: '#F6F6F6',
                color: '#AFAFAF',
                borderRadius: '30px',
                padding: this.state.width <= 800 ? '14px 18px' : this.state.width <= 1100 ? '15px 19px' : '16px 20px',
                fontSize: this.state.width <= 800 ? '16px' : this.state.width <= 1100 ? '17px' : '18px',
                fontWeight: '500',
                border: 'none',
                cursor: 'not-allowed'
              }}
            >
              {this.state.width <= 1000 ? 'Choose date' : 'Next: Choose date'}
            </button>
          </div>
          </>
        ) : null}
        {this.errorModal()}
      </div>
    );
  }

  render() {
    if (this.state.width <= 800) {
      return this.mobileCart();
    }
    return this.desktopCart();
  }
}

const mapStateToProps = (state) => ({
  addresses: state.addresses,
  booking: state.booking,
  products: Object.values(get(state, 'productsReducer.products', {})),
  client: state.client,
  bookingFlow: state.bookingFlow,
  anonymousCart: state.anonymousCart,
  fieldsHolder: state.fieldsHolder,
});

export default connect(mapStateToProps, {
  setCart, setAddresses, setProducts, setAnonymousCart,
})(CartDrawer);
